import React, { useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"

import { UserSelect } from "../../../common/user/selection"
import { BulkPrintInvoicesProps } from "../../../common/types"
import "./styles.scss"

const BulkPrintInvoicesComponent = (props: BulkPrintInvoicesProps) => {
    const default_start = "All invoices will be joined into one pdf file that will be sent to the email of the chosen user."
    const default_end = "You will be able to print the pdf then."
    const [selectedOption, setSelectedOptions] = useState<Array<string>>([])

    return (
        <div>
            <div className={"row d-flex justify-content-center"}>
                <div className={"col-8 pb-4 text-center"}>
                    <em>
                        <FormattedMessage
                            id="bulk.operations.invoices_print.description"
                            defaultMessage={`${default_start} ${default_end}`}
                        />
                    </em>
                </div>
            </div>

            <div className="form-group row mb-1">
                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                    <FormattedMessage
                        id="invoice.bulk_print_invoices.user_select_helper_text"
                        defaultMessage="User to send the pdf to"
                    />
                </label>
                <div className="col-12 col-md-9 mb-3 user-select">
                    <UserSelect
                        multi={true}
                        clearable={false}
                        onChange={(userIds) => {
                            props.onChange({ destinationUserList: userIds as Array<string> })
                            setSelectedOptions(userIds as Array<string>)
                        }}
                        value={selectedOption}
                    />
                </div>
            </div>
        </div>
    )
}

export default injectIntl(BulkPrintInvoicesComponent)



// WEBPACK FOOTER //
// ./src/bulk/operations/bulk-print-invoices/BulkPrintInvoicesComponent.tsx